import { cx } from "../../Utils/helpers";

/** Consistent icon container for feature, service and process cards. */
function IconBox({ icon, size = "md", variant = "soft", round = false, className }) {
  return (
    <span
      className={cx(
        "icon-box",
        size !== "md" && `icon-box--${size}`,
        variant === "solid" && "icon-box--solid",
        round && "icon-box--round",
        className
      )}
      aria-hidden="true"
    >
      {icon}
    </span>
  );
}

export default IconBox;
